import { MedplumClient } from '@medplum/core';

async function hardLogoutFromMedplumSide() {
  console.log('[Medplum] Unauthenticated – forcing global logout');

  // Snapshot UI preferences before clearing. medplum.clear() wipes the whole
  // localStorage, which would otherwise drop the user's theme (and org) on the
  // next page load. These are preferences, not PHI/session data, so they should
  // survive a forced logout. We restore them after the clears below.
  let savedTheme = null;
  let savedOrgId = null;
  try {
    savedTheme = localStorage.getItem('theme');
    savedOrgId = localStorage.getItem('organizationId');
  } catch {
    // ignore
  }

  // Clear PHI cache on logout (HIPAA §164.312(a)(2)(iii))
  try {
    const localforage = (await import('localforage')).default;
    await localforage.clear();
  } catch (e) {
    console.warn('[Medplum] Failed to clear PHI cache on logout:', e);
  }

  try {
    // Clear Medplum tokens/session
    medplum.clear();
  } catch (e) {
    console.warn('[Medplum] Failed to clear Medplum client:', e);
  }

  try {
    fetch('/logout', {
      method: 'GET',
      credentials: 'include',
      cache: 'no-store',
    }).catch(() => {});
  } catch {
    // ignore
  }

  // Clear local storage (rememberMe, email, user, userId, systemAdmin)
  try {
    sessionStorage.setItem('skipAutoLoginOnce', '1');
    localStorage.removeItem('rememberMe');
    localStorage.removeItem('email');
    localStorage.removeItem('user');
    localStorage.removeItem('userId');
    localStorage.removeItem('systemAdmin');
  } catch (e) {
    console.warn('[Medplum] Failed to clear local storage on unauth:', e);
  }

  // Restore the UI preferences the clears above wiped. Theme is read on next
  // mount by getInitialTheme(); org is restored on next login via lastOrgId.
  try {
    if (savedTheme) localStorage.setItem('theme', savedTheme);
    if (savedOrgId) localStorage.setItem('lastOrgId', savedOrgId);
  } catch {
    // ignore
  }

  // Send user to login
  window.location.replace('/#/login');
}

// PKCE-only: browser SPAs must never include a clientSecret in the bundle.
// RFC 8252 (OAuth 2.0 for Native Apps) and the OAuth 2.0 Security BCP both
// prohibit client secrets in public clients. MedplumClient handles PKCE
// automatically when no clientSecret is provided.

export const MEDPLUM_PROJECT_ID = 'db1db704-c7ee-4f78-b847-8ee9160a003f';
const MEDPLUM_BASE_URL = 'https://api.medplum.patientsafetyinc.com';
const MEDPLUM_CLIENT_ID = 'bf34cf53-46e3-4ec2-a7e8-51cd4db59a44';

export const medplum = new MedplumClient({
  baseUrl: MEDPLUM_BASE_URL,
  clientId: MEDPLUM_CLIENT_ID,
  projectId: MEDPLUM_PROJECT_ID,
  refreshGracePeriod: 300000, // 5 min

  onUnauthenticated: () => {
    hardLogoutFromMedplumSide();
  },
});